var u = /* @__PURE__ */ new Set(["glb", "gltf"]), l = /* @__PURE__ */ new Set([
  "spz",
  "ply",
  "splat"
]), w = /* @__PURE__ */ new Set([...u, ...l]), d = /* @__PURE__ */ new Set([
  "jpg",
  "jpeg",
  "png",
  "webp"
]), g = /* @__PURE__ */ new Set(["tif", "tiff"]), c = /* @__PURE__ */ new Set([...d, ...g]), E = /* @__PURE__ */ new Set(["mp4", "webm"]), S = /* @__PURE__ */ new Set([
  "mp3",
  "wav",
  "ogg",
  "opus"
]), h = /* @__PURE__ */ new Set([
  "trace",
  "tracex",
  "zip",
  "glxf"
]), v = /* @__PURE__ */ new Set(["ts"]), A = /* @__PURE__ */ new Set(["json"]), O = /* @__PURE__ */ new Set([
  ...w,
  ...c,
  ...E,
  ...S
]);
function L(t) {
  const e = t.toLowerCase();
  return l.has(e) ? "splat" : u.has(e) ? "model" : c.has(e) ? "image" : E.has(e) ? "video" : S.has(e) ? "audio" : h.has(e) ? "scene" : v.has(e) ? "script" : A.has(e) ? "data" : "unknown";
}
var i = {
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  opus: "audio/ogg",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  gif: "image/gif",
  tif: "image/tiff",
  tiff: "image/tiff",
  glb: "model/gltf-binary",
  gltf: "model/gltf+json",
  json: "application/json"
};
function C(t) {
  const e = t?.split(";")[0].trim().toLowerCase();
  if (e)
    return Object.keys(i).find((a) => i[a] === e);
}
var N = /* @__PURE__ */ new Set(["application/vnd.apple.mpegurl", "application/dash+xml"]), _ = ["video/", "audio/"];
function I(t) {
  if (!t) return !1;
  const e = t.split(";")[0].trim().toLowerCase();
  return e ? N.has(e) || _.some((a) => e.startsWith(a)) : !1;
}
function D(t) {
  if (!t) return !1;
  const e = t.split(";")[0].trim().toLowerCase();
  return e === "model/gltf-binary" || e.startsWith("image/") && e.length > 6 || I(t);
}
function T(t) {
  return i[t.toLowerCase()];
}
function x(t) {
  return g.has(t.toLowerCase());
}
function j(t) {
  return [...t].map((e) => `.${e}`);
}
function P(t) {
  const e = /* @__PURE__ */ new Map();
  for (const [, n] of Object.entries(i)) e.set(n, (e.get(n) ?? 0) + 1);
  const a = /* @__PURE__ */ new Set();
  for (const n of t) {
    const s = T(n);
    if (!s) {
      a.add(`.${n}`);
      continue;
    }
    a.add(s), (e.get(s) ?? 0) > 1 && a.add(`.${n}`);
  }
  return [...a].join(",");
}
function X(t) {
  const e = t.toLowerCase();
  return e.startsWith("data:") ? /^data:image\/png[;,]/.test(e) : e.split(/[?#]/, 1)[0].endsWith(".png");
}
var o = [
  137,
  80,
  78,
  71,
  13,
  10,
  26,
  10
];
async function F(t) {
  try {
    const e = new Uint8Array(await t.slice(0, o.length).arrayBuffer());
    return e.length === o.length && o.every((a, n) => e[n] === a);
  } catch {
    return !1;
  }
}
var r = [
  103,
  108,
  84,
  70
];
async function B(t) {
  try {
    const e = new Uint8Array(await t.slice(0, r.length).arrayBuffer());
    return e.length === r.length && r.every((a, n) => e[n] === a);
  } catch {
    return !1;
  }
}
var M = /\.(?:html?|xhtml|svg)$/i, b = /^\uFEFF?\s*(?:<!doctype\s+html|<html[\s>]|<\?xml[^>]*\?>\s*(?:<!doctype\s+html|<html[\s>]))/i, y = /^\uFEFF?\s*</;
function G(t, e, a) {
  const n = t.split(/[?#]/)[0];
  if (M.test(n)) return !1;
  const s = new Uint8Array(a, 0, Math.min(a.byteLength, 256));
  if (r.every((m, p) => s[p] === m)) return !1;
  const f = new TextDecoder("utf-8", { fatal: !1 }).decode(s);
  return b.test(f) ? !0 : !!e && /^\s*text\/html\b/i.test(e) && y.test(f);
}
export {
  T as C,
  G as S,
  j as T,
  x as _,
  O as a,
  F as b,
  d as c,
  l as d,
  N as f,
  X as g,
  L as h,
  g as i,
  h as l,
  C as m,
  S as n,
  c as o,
  E as p,
  A as r,
  u as s,
  w as t,
  v as u,
  D as v,
  P as w,
  I as x,
  B as y
};

//# sourceMappingURL=AssetTypes-DUDo9FdH.js.map